import React from 'react';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StoreIcon from '@mui/icons-material/Store';
import PersonIcon from '@mui/icons-material/Person';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BuildIcon from '@mui/icons-material/Build';
import LanguageIcon from '@mui/icons-material/Language';

export const supportCategories = [
  { category: 'Pricing', icon: <MonetizationOnIcon /> },
  { category: 'Inventory', icon: <StoreIcon /> },
  { category: 'User', icon: <PersonIcon /> },
  { category: 'Sales', icon: <TrendingUpIcon /> },
  { category: 'Admin', icon: <BuildIcon /> },
  { category: 'Web Menu', icon: <LanguageIcon /> }
];

export const supportVideoList = [
  {
    category: 'Admin',
    supportVideos: [
      {
        title: "Cash Registers", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/MW4T8Ij8wdE",
        description: "Learn how to operate cash registers."
      },
      {
        title: "Marketing", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/bGp7olZmFO8",
        description: "Explore strategies to improve your marketing."
      },
      {
        title: "Orders Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/zuZLSVkYyq8",
        description: "Navigate the orders page with ease."
      },
      {
        title: "Schedules", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/QAUqu4bdo0I",
        description: "Learn how to manage schedules."
      },
      {
        title: "Shifts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/7R2EQKp3TXs",
        description: "Manage your team's shifts efficiently."
      },
      {
        title: "System Settings", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/pWJTBDHfkE0",
        description: "Understand how to navigate system settings."
      }
    ]
  },
  {
    category: 'Inventory',
    supportVideos: [
      {
        title: "Accessory Vendor Catalogs", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Ab7I_-m9Fjw",
        description: "Navigate through accessories vendor catalogs."
      },
      {
        title: "Bulk Transfer", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/b_lFKQ37nFQ",
        description: "Learn how to perform bulk transfers."
      },
      {
        title: "Categories", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/IrEFekhPOfw",
        description: "Understand how to organize your inventory into categories."
      },
      {
        title: "Inventory Audit", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/IZq7KrkLoHU",
        description: "Learn how to perform an inventory audit."
      },
      {
        title: "Manual Purchase Order Creation", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/gsBZHN8YIT8",
        description: "Understand how to manually create purchase orders."
      },
      {
        title: "Purchase Order Overview", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/TtA_hkjjygE",
        description: "Get an overview of the purchase order functionality."
      },
      {
        title: "Product Hub", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/rNYVWWmKCQk",
        description: "Explore the features of the product hub."
      },
      {
        title: "Products Page", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/6XbLN6Zhk1A",
        description: "Learn how to manage your products page."
      },
      {
        title: "Warehouse", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/yb4JTJNfFDM",
        description: "Understand the functions of the warehouse feature."
      }
    ]
  },
  {
    category: 'Pricing',
    supportVideos: [
      {
        title: "Campaigns", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/Khj2hF2KwYI",
        description: "Understand how to set up and manage campaigns."
      },
      {
        title: "Combos", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/i46qZpMpoqk",
        description: "Learn how to create and manage product combos."
      },
      {
        title: "Customized Discounts", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/SFvFykgP-FI",
        description: "Learn how to offer customized discounts."
      },
      {
        title: "Measurement and Matrix", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/GUmTDQEEN9E",
        description: "Understand the pricing measurement and matrix system."
      }
    ]
  },
  {
    category: 'Sales',
    supportVideos: [
      {
        title: "Making a Retail Sale", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/OWvJRey_byY",
        description: "Learn the process of making a retail sale."
      }
    ]
  },
  {
    category: 'User',
    supportVideos: [
      {
        title: "Employees", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/zLkPg6MirTA",
        description: "Learn how to manage your employee user accounts."
      },
      {
        title: "Members", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/YV8ovULv00k",
        description: "Understand how to manage member user accounts."
      },
      {
        title: "User Roles", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/LMS7jo9Et4U",
        description: "Learn about different user roles and their permissions."
      }
    ]
  },
  {
    category: 'Web Menu',
    supportVideos: [
      {
        title: "Carousels", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/L1vmUPtoKro",
        description: "Learn how to create and manage carousels."
      },
      {
        title: "Online Orders", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/_yX-ZzgYsgs",
        description: "Understand how to manage online orders."
      },
      {
        title: "Store Rules", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/J3Er3stZV7o",
        description: "Learn about setting up and enforcing store rules."
      },
      {
        title: "Web Categories", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/hovTmYgDzEc",
        description: "Understand how to manage web categories."
      },
      {
        title: "Web UI Menu", thumbnailUrl: "https://i.imgur.com/6QZ1nqE.jpg", videoUrl: "https://youtu.be/nWYQgWMSgi0",
        description: "Learn about the layout and functionality of the web UI menu."
      }
    ]
  }
];
